'use client';
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogTitle,
  DialogTrigger,
  Hamburger,
  Close,
  VisuallyHidden
} from '@baseline/ui';
import LogoLink from '@/components/Header/components/LogoLink';
import MobileMenuLink from './components/MobileMenuLink';
import type { NavigationItem } from '@/components/Header/links';
import { useState } from 'react';
import styles from './mobileMenu.module.scss';
import DemoButton from '@/components/buttons/DemoButton';

type MobileMenuProps = {
  navItems: NavigationItem[];
};

export default function MobileMenu({ navItems }: MobileMenuProps) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogTrigger asChild>
        <button className={styles.trigger} aria-label="open navigation menu">
          <Hamburger />
        </button>
      </DialogTrigger>
      <DialogContent dismissable={false} className={styles.menu}>
        <VisuallyHidden>
          <DialogTitle>Mobile Navigation Menu</DialogTitle>
          <DialogDescription>Links to navigate the site</DialogDescription>
        </VisuallyHidden>
        <div className={styles.header}>
          <LogoLink
            onClick={() => {
              setIsOpen(false);
            }}
          />
          <div className={styles.actions}>
            <DialogClose
              className={styles.close}
              aria-label="close navigation menu"
            >
              <Close />
            </DialogClose>
          </div>
        </div>
        <div className={styles.links}>
          {navItems.map((link) => (
            <MobileMenuLink
              key={link.title}
              onClick={() => setIsOpen(false)}
              {...link}
            />
          ))}
        </div>
        <div className={styles.demoButton} onClick={() => setIsOpen(false)}>
          <DemoButton />
        </div>
      </DialogContent>
    </Dialog>
  );
}
